// extracted by mini-css-extract-plugin
export default {"tabs":"job-tabs_tabs__XVRVu","tab":"job-tabs_tab__5qrCV","active":"job-tabs_active__Vte5-"};